import React, { Component } from "react";
import Page from "./util/Router/Page";
import routes from "./util/Router/routes";
import "./App.css";
import { connect } from "react-redux";
import AlertComponent from "./components/AlertComponent";
import { hidePostModal as hidePostModalAction, hideDownloadAppDialog } from "./actions";
import PostModal from "./components/PostModal";
import SignInModal from "./components/SignInModal";
import ConfirmationModal from "./components/ConfirmationModal";
import { Fragment } from "redux-little-router";
import NotFoundPage from "./scenes/App404";
import { selectUser } from "./util/selectors";
import { Helmet } from "react-helmet";
import OnBoardingDimmer from "./components/OnBoardingDimmer";
import userActions from "./actions/userActions";
import { Notifs } from "redux-notifications";
import Intercom from "./components/Intercom";
import DownloadAppDialog from "./components/DownloadAppDialog";
import { getMobileOS } from "./util";
import AddToCollectionModal from "./components/AddToCollectionModal";
import CollectionFormModal from "./components/CollectionFormModal";

class App extends Component {
  showAlert = (message, type) => {
    this.alert.show(message, {
      type,
    });
  };

  render() {
    return (
      <div className="app">
        <Helmet>
          <title>Casemasters | Social Network for Dentists to Share Dental Cases & Learn</title>
          <link rel="alternate" href="https://wwww.casemasters.com/" hreflang="en" />
          <meta
            name="description"
            content="Casemasters is the Social Network for dentists where global dental experts come together to share their experience, learn, discuss and communicate with each other. Join Casemasters now and be part of our global dental community."
          />
          <meta property="og:title" content="Casemasters | Social Network for Dentists to Share Dental Cases & Learn" />
          <meta
            property="og:description"
            content="Casemasters is the Social Network for dentists where global dental experts come together to share their experience, learn, discuss and communicate with each other. Join Casemasters now and be part of our global dental community."
          />
          <meta property="og:image" content="https://casemasters.azureedge.net/public/fbpost-v-zXr4v4onaL.jpg" />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:url" content="https://www.casemasters.com" />
        </Helmet>
        <Fragment forRoute="/">
          <div>
            {routes.map((route, index) => <Page key={index} {...route} />)}
            <Fragment withConditions={location => !location.route}>
              <NotFoundPage />
            </Fragment>
          </div>
        </Fragment>
        <Notifs CustomComponent={AlertComponent} />
        <PostModal
          post={this.props.post}
          isOpen={this.props.isPostModalOpen}
          actions={this.props.actions}
          user={this.props.user}
        />
        <SignInModal isOpen={this.props.isSignInModalOpen} message={this.props.signInModalMessage} user={this.props.user} />
        <ConfirmationModal {...this.props.confirmationModalOptions} />
        <Intercom />
        {this.handleOnboardingDimmerRendering()}
        {this.props.isDownloadAppDialogVisible && (
          <DownloadAppDialog mobileOS={getMobileOS()} closeDialog={this.props.actions.hideDownloadAppDialog} />
        )}
        {this.props.isAddToCollectionModalVisible && <AddToCollectionModal />}
        {(this.props.isNewCollectionFormModalOpen || this.props.isEditCollectionFormModalOpen) && (
          <CollectionFormModal />
        )}
      </div>
    );
  }

  handleOnboardingDimmerRendering() {
    const isDimmerOpen = this.props.isOnboardingDimmerOpen || this.props.isProfileUpdateDimmerOpen;
    if (!this.props.user || !isDimmerOpen) {
      return null;
    }

    const submitFunction = this.props.isOnboardingDimmerOpen
      ? this.handleOnBoardingDimmerSubmit
      : this.handleProfileUpdateFormSubmit;
    return (
      <OnBoardingDimmer
        isOpen={isDimmerOpen}
        user={this.props.user}
        isCreatingProfile={this.props.isCreatingProfile}
        displayFields={this.props.onboardingDisplayFields}
        msg={this.props.onboardingMessage}
        onSubmit={submitFunction}
      />
    );
  }

  handleOnBoardingDimmerSubmit = (profileData, handleSubmitErrors) => {
    this.props.actions.submitOnboardingForm(profileData, handleSubmitErrors);
  };

  handleProfileUpdateFormSubmit = (profileData, handleSubmitErrors) => {
    this.props.actions.submitProfileUpdateForm(profileData, handleSubmitErrors);
  };
}

const mapStateToProps = state => {
  return {
    user: selectUser(state),
    alert: state.alert,
    post: state.posts.current,
    isPostModalOpen: state.posts.isPostModalOpen,
    isSignInModalOpen: state.user.isSignInModalOpen,
    signInModalMessage: state.user.signInModalMessage,
    confirmationModalOptions: state.confirmationModal,
    isUserProfileFetched: state.user.isUserProfileFetched,
    isOnboardingDimmerOpen: state.user.onboarding.isOnboardingDimmerOpen,
    isProfileUpdateDimmerOpen: state.user.onboarding.isProfileUpdateDimmerOpen,
    onboardingMessage: state.user.onboarding.onboardingMessage,
    onboardingDisplayFields: state.user.onboarding.onboardingDisplayFields,
    isCreatingProfile: state.user.isCreatingProfile,
    isDownloadAppDialogVisible: state.ui.isDownloadAppDialogVisible,
    isNewCollectionFormModalOpen: state.ui.collectionFormModal.isNewCollectionFormModalOpen,
    isEditCollectionFormModalOpen: state.ui.collectionFormModal.isEditCollectionFormModalOpen,
    isAddToCollectionModalVisible: state.ui.addToCollectionModal.isVisible,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      hideModal: () => dispatch(hidePostModalAction()),
      fetchUserExtraProfileData: uid => dispatch(userActions.fetchUserExtraProfileData(uid)),
      submitOnboardingForm: (profileData, handleSubmitErrors) =>
        dispatch(userActions.createProfile(profileData, handleSubmitErrors)),
      submitProfileUpdateForm: (profileData, handleSubmitErrors) =>
        dispatch(userActions.updateProfile(profileData, handleSubmitErrors)),
      hideDownloadAppDialog: () => dispatch(hideDownloadAppDialog()),
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js